import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { config } from 'config';
import * as moment from 'moment/moment';
var API_BASE_URL = config.apiBaseUrl[process.env.NODE_ENV];
var ServiceInterface = /** @class */ (function () {
    function ServiceInterface(_http) {
        this._http = _http;
    }
    ServiceInterface.prototype.getList = function (apiName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newdate, resultMap, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newdate = moment(new Date()).format('MMDDYYYY_hhmmss');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.get(API_BASE_URL + apiName + "?dt=" + newdate).map(function (response) {
                                var result = response.data;
                                return result;
                            }).toPromise()];
                    case 2:
                        resultMap = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.log('xhr error!', err_1);
                        throw err_1;
                    case 4: return [2 /*return*/, resultMap];
                }
            });
        });
    };
    ServiceInterface.prototype.get = function (apiName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newdate, resultMap, err_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newdate = moment(new Date()).format('MMDDYYYY_hhmmss');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.get(API_BASE_URL + apiName + "?dt=" + newdate).map(function (response) {
                                var result = response.data;
                                return result;
                            }).toPromise()];
                    case 2:
                        resultMap = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        console.log('xhr error!', err_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, resultMap];
                }
            });
        });
    };
    ServiceInterface.prototype.post = function (apiName, model) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resultMap, err_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._http.post(API_BASE_URL + apiName, model).map(function (response) {
                                var result = response.data;
                                return result;
                            }).toPromise()];
                    case 1:
                        resultMap = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_3 = _a.sent();
                        console.log('xhr error!', err_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, resultMap];
                }
            });
        });
    };
    return ServiceInterface;
}());
export { ServiceInterface };



// WEBPACK FOOTER //
// ./src/services/service.interface.ts.pre-build-optimizer.js